import {API_HOST} from "@/helpers/stipe_const";

function performGetRequest(url) {
  return fetch(url)
    .then(data => data.json())
    .catch(e => console.log(e));
}

function performPostRequest(body, url) {
  const options = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body)
  };

  return fetch(url, options).then(data => {
    if (!data.ok) {
      throw Error(data.status);
    }
    return data.json();
  }).catch(e => {
    console.log(e);
  });
}

const getSubscriptions = async (customerId, testPayment = false) => {
  return performGetRequest(`${API_HOST}/api/subscriptions?customerId=${customerId}${testPayment ? '&test=1' : ''}`);
/*  return fetch(`${API_HOST}/api/subscriptions?customerId=${customerId}${testPayment ? '&test=1' : ''}`, {})
    .catch(e => console.log(e))
    .then(r => r.json());*/
}

const createSubscription = async (customerId, selectedPrice, testPayment, trial) => {
  return performGetRequest(`${API_HOST}/api/create-subscription?customerId=${customerId}&priceId=${selectedPrice}${testPayment ? '&test=1' : ''}${trial ? '&trial=1' : ''}`);
}

const cancelSubscription = async (customerId, subscriptionId, testPayment = false) => {
  return performGetRequest(`${API_HOST}/api/cancel-subscription?customerId=${customerId}&subscriptionId=${subscriptionId}${testPayment ? '&test=1' : ''}`);
}

const createCustomerStripe = async (userEmail, testPayment, methodID) => {
  return performGetRequest(`${API_HOST}/api/create-customer?email=${encodeURIComponent(userEmail)}${testPayment ? '&test=1' : ''}${methodID ? '&methodID=' + methodID : ''}`);
}

const getUserByEmail = async (userEmail) => {
  return performGetRequest(`${API_HOST}/api/getUserByEmail?email=${encodeURIComponent(userEmail)}`);
}

const getPricesFromStripe = (testPayment = false) => {
  const pricesResponses = performGetRequest(`${API_HOST}/api/config${testPayment ? '?test=1' : ''}`);
  return pricesResponses.prices;
}

const setClaim = (body) => {
  return performPostRequest(body, `${API_HOST}/api/setClaim`);
  //return performGetRequest(`${API_HOST}/api/setClaim?uid=${uid}&linkedUid=${linkedUid}`);
}

function createActiveCampaignContact(credentials) {
  const body = {credentials};
  return performPostRequest(body, `${API_HOST}/api/createACContact`);
}

function addToActiveCampaignPremiumList(email, plan) {
  const body = {
    email: email,
    plan: plan,
  };
  return performPostRequest(body, `${API_HOST}/api/addToACPremiumList`);
}

function addToActiveCampaignList(body) {
  return performPostRequest(body, `${API_HOST}/api/addToACList`);
}

function addActiveCampaignTag(body) {
  return performPostRequest(body, `${API_HOST}/api/ACAddContactTag`);
}

function removeActiveCampaignTag(body) {
  return performPostRequest(body, `${API_HOST}/api/ACRemoveContactTag`);
}

export {
  getSubscriptions,
  createSubscription,
  cancelSubscription,
  createCustomerStripe,
  getPricesFromStripe,
  getUserByEmail,
  setClaim,
  createActiveCampaignContact,
  addToActiveCampaignPremiumList,
  addToActiveCampaignList,
  addActiveCampaignTag,
  removeActiveCampaignTag,
}